import React from "react";
import useNflTeams from "../../hooks/queryResults/nfl/useNflTeams";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import Util from "../../util/util";
import Loading from "../ui/Loading";

export default function NflGamePlayByPlay({ nflGameStatsData }) {
  console.log("nflGameStatsData", nflGameStatsData);
  const { nflTeamsData, nflTeamsQuery } = useNflTeams();

  const isLoading = useIsLoading(nflGameStatsData, nflTeamsData, nflTeamsQuery);
  if (isLoading) return <Loading />;

  const drives = Object.keys(nflGameStatsData.nflGameStats.drives).map(
    (driveId) => nflGameStatsData.nflGameStats.drives[driveId]
  );

  drives.sort((a, b) => {
    return a.num <= b.num ? -1 : 1;
  });

  const nflTeams = {};

  const getNflTeamById = (teamId) => {
    if (!nflTeams.hasOwnProperty(teamId)) {
      const abbrevs = Object.keys(nflTeamsData.nflTeams);
      for (const abbr of abbrevs) {
        const team = nflTeamsData.nflTeams[abbr];
        if (team.id === teamId) {
          nflTeams[teamId] = team;
          break;
        }
      }
    }

    return nflTeams[teamId];
  };

  return (
    <div style={{ color: "#000" }}>
      {drives.map((drive, i) => {
        const {
          offNflTeam,
          plays,
          quarter,
          result,
          score,
          timeOfPoss,
          totalPlays,
          yds,
        } = drive;

        const nflTeam = getNflTeamById(offNflTeam);

        const quarterOrdinal =
          quarter === "OT" ? "OT" : Util.toOrdinal(quarter);

        return (
          <div key={i} style={{ marginBottom: "2rem" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "#eee",
                color: "#0078f8",
                padding: "0.5rem",
                fontWeight: "bold",
              }}
            >
              <div>
                {quarterOrdinal} quarter - {nflTeam.city} {nflTeam.nickname}{" "}
                drive - resulted in {result}
              </div>
              <div>
                {totalPlays} plays, {yds} yards, {timeOfPoss}
              </div>
              <div>
                {nflGameStatsData.nflGameStats.away.abbr} {score}{" "}
                {nflGameStatsData.nflGameStats.home.abbr}
              </div>
            </div>
            <table style={{ width: "100%" }}>
              <tbody>
                {plays.map((play, i) => {
                  const { ballOn, clock, description, distance, down } = play;

                  const downDistance = (
                    <>
                      {down || distance ? (
                        <>
                          {Util.toOrdinal(down)} & {distance || "Goal"}
                        </>
                      ) : null}
                      {ballOn ? (
                        <>
                          <br />
                          at {ballOn}
                        </>
                      ) : null}
                    </>
                  );

                  const special = [];

                  if (play.isScoringPlay) special.push("Sc");
                  if (play.isFieldGoalAttempt) special.push("FG");
                  if (play.isSpecialTeams) special.push("ST");
                  if (play.isPenalty) special.push("P");
                  if (play.isTurnover) special.push("TO");

                  return (
                    <tr key={i}>
                      <td>
                        {quarterOrdinal}
                        <br />
                        {clock}
                      </td>
                      <td className={"left"} style={{ whiteSpace: "nowrap" }}>
                        {downDistance}
                      </td>
                      <td className={"left"}>{description}</td>
                      <td style={{ whiteSpace: "nowrap" }}>
                        {special.join(",")}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}
